import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden pt-28 pb-20 lg:pt-32 lg:pb-24" data-id="element-130">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-131">
        <div className="grid grid-cols-1 gap-12 items-center" data-id="element-132">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center max-w-3xl mx-auto" data-id="element-133">
            <div className="px-6 py-4 rounded-3xl bg-gradient-to-r from-violet-500 via-orange-500 to-violet-500 text-white font-extrabold text-3xl sm:text-4xl lg:text-5xl mb-4 leading-tight shadow-lg" data-id="element-134">
              ¿Cansada de pensar qué cocinar todos los días?
            </div>

            <p className="text-xl text-gray-700 mb-4 leading-relaxed" data-id="element-135">
              ¡Resolvé la comida de todos los dias en forma rápida y practica
              con recetas nutritivas y saludables que tienen verduras que ni se
              notan 🥦✨!
            </p>

            <div className="px-6 py-4 rounded-3xl bg-gradient-to-r from-orange-500 via-violet-500 to-emerald-500 text-white font-extrabold text-3xl sm:text-4xl lg:text-5xl mb-6 leading-tight shadow-lg" data-id="element-136">
              ¿Tu hijo se niega a probar verduras y cada comida se convierte en
              una batalla?
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="mb-6 rounded-2xl overflow-hidden shadow-lg border-4 border-emerald-300" data-id="element-137">
              <img src="https://cdn.magicpatterns.com/uploads/rueyTBTWirX8tFBqKabGa7/chicosllorandoheylloyd-image-1771674483003.png" alt="Niños rechazando verduras en la mesa" className="w-full object-cover" data-id="element-138" />
            </motion.div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight text-gray-900 mb-6" data-id="element-139">
              ¿Y si tus hijos comieran sano y con verduras{' '}
              <span className="text-violet-600" data-id="element-140">sin darse cuenta?</span>
            </h1>

            <p className="text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-141">
              Con nuestras recetas, vas a ver platos vacíos y escuchar:
              <span className="font-bold italic text-emerald-600" data-id="element-142">
                {' '}
                "¡Quiero más!"{' '}
              </span>
              en solo 15 minutos. Esta es la solución para que coman saludable
              sin llantos ni peleas.
            </p>

            <div className="flex flex-col items-center gap-4 justify-center lg:justify-start" data-id="element-143">
              <div className="w-full flex flex-col items-center justify-center gap-1 px-4 bg-violet-600 rounded-2xl py-4" data-id="element-144">
                <div className="flex items-center gap-2" data-id="element-145">
                  <div className="flex text-yellow-400" data-id="element-146">
                    <Star className="h-5 w-5 fill-current" data-id="element-147" />
                    <Star className="h-5 w-5 fill-current" data-id="element-148" />
                    <Star className="h-5 w-5 fill-current" data-id="element-149" />
                    <Star className="h-5 w-5 fill-current" data-id="element-150" />
                    <Star className="h-5 w-5 fill-current" data-id="element-151" />
                  </div>
                  <span className="text-white font-bold text-sm" data-id="element-152">
                    4.9/5 (opiniones verificadas)
                  </span>
                </div>
                <p className="text-white font-extrabold text-base" data-id="element-153">
                  ✨ Garantía de 60 DÍAS ✨
                </p>
              </div>
              <motion.button onClick={() => {
              const el = document.getElementById('comprar-ahora');
              if (el) el.scrollIntoView({
                behavior: 'smooth'
              });
            }} whileHover={{
              scale: 1.07,
              boxShadow: '0 0 50px rgba(251,191,36,0.85), 0 0 25px rgba(251,146,60,0.7)'
            }} whileTap={{
              scale: 0.96
            }} transition={{
              type: 'spring',
              stiffness: 300,
              damping: 18
            }} className="w-full bg-gradient-to-r from-yellow-400 to-orange-500 text-gray-900 font-extrabold text-xl px-10 py-5 rounded-full shadow-2xl cursor-pointer border-4 border-yellow-200 flex items-center justify-center gap-3" data-id="element-154">
                🛒 Obtener Recetas Ahora
                <ArrowRight className="h-6 w-6" data-id="element-155" />
              </motion.button>

              <p className="text-lg font-extrabold text-gray-800" data-id="element-156">
                🔥 Antes{' '}
                <span className="line-through text-gray-400" data-id="element-157">$29.900</span> —
                Hoy <span className="text-emerald-600" data-id="element-158">$6.900</span>
              </p>
              <p className="text-base font-bold text-violet-600" data-id="element-159">
                🎁 + de regalo 5 bonos valorados en{' '}
                <span className="line-through text-gray-400" data-id="element-160">$24.300</span>{' '}
                totalmente{' '}
                <span className="text-emerald-600 font-extrabold" data-id="element-161">
                  ¡GRATIS!
                </span>
              </p>
              <p className="text-sm font-semibold text-gray-500" data-id="element-162">
                📩 Acceso inmediato al eBook después del pago, se envía a tu
                correo electrónico
              </p>
            </div>
          </motion.div>

          {/* Image Content - hidden, kept for decoration only */}
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="hidden" data-id="element-163">
            <div className="absolute inset-0 bg-orange-200 rounded-3xl transform rotate-3 scale-95 blur-xl opacity-50 -z-10" data-id="element-164"></div>
          </motion.div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-violet-200 rounded-full blur-3xl opacity-50 -z-10" data-id="element-165"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-emerald-200 rounded-full blur-3xl opacity-60 -z-10" data-id="element-166"></div>
    </section>;
}